import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "g-row g-row--align_center g-row--appearance_spaced g-row--space_lg-lg g-row--space_xl-xl mo-space_mt mo-space_mt--5" }
const _hoisted_2 = { class: "global-error" }
const _hoisted_3 = { class: "g-cell g-cols g-cols--12 mo-space_mt mo-space_mt--5 mo-space_mt--8-lg" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "mo-button__text" }
const _hoisted_6 = { class: "g-cell g-cols g-cols--12 mo-space_mt mo-space_mt--5 mo-space_mt--8-lg" }
const _hoisted_7 = { class: "ds-caption ds-caption--size_sm ds-caption--size_md-xl ds-caption--color_text_11 ds-caption--medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_vee_error = _resolveComponent("vee-error")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createBlock(_component_VeeForm, {
    onSubmit: $setup.request,
    ref: "formRef"
  }, {
    default: _withCtx(({ errors, validate, values, setErrors, setFieldError, isSubmitting }) => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.FIELDS, ({ name, label, mask, size, classes, ...rest }) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["g-cell g-cols g-cols--12", `g-cols--${size || 6}-lg ${classes ?? ''}`])
            }, [
              _createVNode(_component_d_control_input, _mergeProps({
                class: "is-public",
                name: name,
                errors: errors,
                "input-label": label,
                "static-label": label,
                modelValue: $setup.form[name],
                "onUpdate:modelValue": ($event: any) => (($setup.form[name]) = $event),
                id: name,
                ref_for: true
              }, rest), _createSlots({ _: 2 }, [
                _renderList(rest.slots, (_slot) => {
                  return {
                    name: _slot.name,
                    fn: _withCtx((r) => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_slot.component), _mergeProps({ ref_for: true }, _slot.props), null, 16))
                    ])
                  }
                })
              ]), 1040, ["name", "errors", "input-label", "static-label", "modelValue", "onUpdate:modelValue", "id"])
            ], 2))
          }), 256)),
          _createVNode(_component_vee_error, {
            class: "g-cell g-cols g-cols--12",
            name: "nonFieldErrors",
            as: "div"
          }, {
            default: _withCtx(({ message }) => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(message), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "mo-button mo-button--variant_primary mo-button--slim",
              type: "submit",
              disabled: isSubmitting || $setup.isLoad
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString($setup.$t('Save and continue')), 1)
            ], 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString($setup.$t("*The coordinator manages the medical facility profile, services, records, and settings.")), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}